<template>
  <div id="app">
    <div id="preload">
      <img src="./assets/imgs/home.jpg" />
      <img src="./assets/imgs/comentario_ceo.jpg" />
      <img src="./assets/imgs/arrecadacao.jpg" />
      <img src="./assets/imgs/distribuicao.jpg" />
      <img src="./assets/imgs/diretordeoperacoes.jpg" />
      <img src="./assets/imgs/numeros2025.jpg" />
      <img src="./assets/imgs/principais_atividades.jpg" />
    </div>
    <div class="menu" v-bind:class="{ isOpen: hamburguerState }">
      <nav>
        <ul>
          <li><router-link to="/"><span v-on:click="checkHamburguer()">Intro</span></router-link></li>
          <li><router-link to="/FewWordFromOurCEO"><span v-on:click="checkHamburguer(), checkIsTransition()">A Few Words from our CEO</span></router-link></li>
          <li><router-link to="/Collections"><span v-on:click="checkHamburguer(), checkIsTransition()">Collections</span></router-link></li>
          <li><router-link to="/Distributions"><span v-on:click="checkHamburguer(), checkIsTransition()">Distributions</span></router-link></li>
          <li><router-link to="/OurChiefOperatingOfficersAnalysiss"><span v-on:click="checkHamburguer(), checkIsTransition()">An Analysis From Our COO</span></router-link></li>
          <li><router-link to="/UBCNumbersIn2025"><span v-on:click="checkHamburguer(), checkIsTransition()">UBC Numbers In 2025</span></router-link></li>
          <li><router-link to="/MainActivities"><span v-on:click="checkHamburguer(), checkIsTransition()">Main Activities</span></router-link></li>
        </ul>
      </nav>
    </div><!-- menu -->
    <div class="abertura"
         :class="setBackground"
    ></div> 
    <div class="magic">
      <div class="canto" 
           :class="{ 
            'conteudoIntPart1': isInternal, 
            'conteudoCantoIntTrans': isTransition
            }"
      >
        <div class="cantoBranco"></div>
        <div class="cantoCurva">
            <img src="./assets/imgs/curvacanto.png">
        </div>
      </div><!-- canto -->
      <div class="conteudo" 
           :class="{
             'conteudoIntPart2': isInternal, 
             'conteudoIntTrans': isTransition
             }" 
      >
        <transition name="testao">
        <router-view v-on:go-next="goNext" v-on:go-back="goBack" ></router-view>
        </transition>
      </div><!-- conteudo -->
      <div class="ubc"
           :class="{
             'conteudoIntPart3': isInternal, 
             'ubcIntTrans': isTransition
           }"
      >
        <div class="botaoIniciar btHome" 
             :class="{'botaoIniciarOff': isInternal}">
            <router-link class="boxInicio" to="/FewWordFromOurCEO">
              <span class="move"><i class="right"></i></span>
            </router-link>
        </div>
        <div class="ubcImg">
          <img src="./assets/imgs/ubcpart.png">
        </div>
      </div><!-- ubc -->
      
      <div class="botaoIniciar btHomeMob" 
             :class="{'botaoIniciarOff': isInternal}">
            <router-link class="boxInicio" to="/FewWordFromOurCEO">
              <span class="move"><i class="right"></i></span>
            </router-link>
        </div>

      <transition name="fadeMenuHorizontal">
        <div v-if="menuHorizontal" class="menuBar">
          <div class="homeBarHorizontal">
              <div class="titulo"><h1>Annual Report 2025</h1></div>
              <div class="boxDirHor">
              <div class="idioma">
                <a href="https://hotsite.ubc.org.br/Hotsite/Relatorio_Anual/2025/"><div>PORT</div></a>
                <a href="https://hotsite.ubc.org.br/Hotsite/Relatorio_Anual/2025/esp"><div>ESP</div></a>
                <div class="active-idiom">ENG</div>
              </div> 
                <div class="equaliser-container" v-on:click="checkMusicState">
                  <div :class="{ icoMusicState: musicState }" 
                        class="icoMusic">&#9835;
                  </div>
                  <ol class="equaliser-column">
                    <li class="staticSoundBar"
                        :class="{ colourBar: musicState }"></li>
                  </ol>
                  <ol class="equaliser-column">
                    <li class="staticSoundBar"
                        :class="{ colourBar: musicState }"></li>
                  </ol>
                  <ol class="equaliser-column">
                    <li class="staticSoundBar"
                        :class="{ colourBar: musicState }"></li>
                  </ol>
                  <ol class="equaliser-column">
                    <li class="staticSoundBar"
                        :class="{ colourBar: musicState }"></li>
                  </ol>
                  <ol class="equaliser-column">
                    <li class="staticSoundBar"
                        :class="{ colourBar: musicState }"></li>
                  </ol>
                </div>
              </div>
          </div><!-- homeBarHorizontal -->     
        </div><!-- menuBar -->
      </transition> 

      <div class="hamburguerdiv">
        <button class="hamburger hamburger--collapse" v-on:click="checkHamburguer" type="button" v-bind:class="{ isActive: hamburguerState }">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
        </button>
      </div>

      <div class="tituloCelVert"><h1>Annual Report 2025</h1></div>  

      <transition name="fadeMenuVertical">
      <div v-if="menuVertical" class="menuBarVertical">
        <div class="equaliser-container" v-on:click="checkMusicState" style="margin:70px 0 0 0 !important; align-self: center;">
          <div :class="{ icoMusicState: musicState }" 
                        class="icoMusic">&#9835;
          </div>
          <ol class="equaliser-column">
            <li class="staticSoundBar"
                :class="{ colourBar: musicState }"></li>
          </ol>
          <ol class="equaliser-column">
            <li class="staticSoundBar"
                :class="{ colourBar: musicState }"></li>
          </ol>
          <ol class="equaliser-column">
            <li class="staticSoundBar"
                :class="{ colourBar: musicState }"></li>
          </ol>
          <ol class="equaliser-column">
            <li class="staticSoundBar"
                :class="{ colourBar: musicState }"></li>
          </ol>
          <ol class="equaliser-column">
            <li class="staticSoundBar"
                :class="{ colourBar: musicState }"></li>
          </ol>
        </div>
        <div class="titulo"><h1>Annual Report 2025</h1></div>    
      </div><!-- menuBarVertical -->
      </transition>

    </div><!-- magic --> 
    <audio id="myAudio" ref="music">
      <source src="./assets/audio/music.mp3" type="audio/mpeg">
      Your browser does not support the audio element.
    </audio>
  </div><!-- app -->
</template>

<script>

export default {
  name: 'App',
  
  data() {
    return{
      isInternal: false,
      menuHorizontal: true,
      menuVertical: false,
      hamburguerState: false,
      isTransition: false,
      clicked: false,
      musicState: false,
      setBackground:[],
    }
  },
  created(){
    this.checkPath();
    // let lastKeyTime = Date.now();
    document.onkeydown = this.onkeydown;
  },
  
  watch: {
    '$route.path': 'checkPath',  
  },

  methods:{
      playAudio:function()  { 
        this.$refs.music.play(); 
      },
      checkPath: function(){
        let route = this.$route.path
        this.setBackground = route
        let resultado = this.setBackground.replace("/", "back-");
        this.setBackground = resultado

        if (route != "/") {
          this.isInternal = true,
          this.menuHorizontal = false,
          this.menuVertical = true 
        } else { 
          this.isInternal = false,
          this.menuHorizontal = true,
          this.menuVertical = false 
        }
        
      },
      checkHamburguer: function(){
        this.hamburguerState = !this.hamburguerState
      },
      checkMusicState: function(){
        this.musicState = !this.musicState
        if (this.$refs.music.paused) {
        this.$refs.music.play();
        }
        else {
            this.$refs.music.pause();
        }
      },
      checkIsTransition: function(){
        let pathatual = this.$route.path;
        if (pathatual === "/") {
        // nada
        }else{
        this.isTransition = !this.isTransition

        let self = this
        setTimeout(function(){self.isTransition = false}, 1499,);
        }
      },
      goNext: function(){
        this.clicked = true;
        setTimeout(function(){
           this.clicked = false;
        }.bind(this),1499);
        let pathatual = this.$route.path;
        if (pathatual === "/FewWordFromOurCEO") {
          this.$router.push('Collections')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){ self.isTransition = false }, 1499);
        }else if (pathatual === "/Collections") {
          this.$router.push('Distributions')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){ self.isTransition = false }, 1499);
        }else if (pathatual === "/Distributions") {
          this.$router.push('OurChiefOperatingOfficersAnalysiss')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){ self.isTransition = false }, 1499);
        }else if (pathatual === "/OurChiefOperatingOfficersAnalysiss") {
          this.isTransition = !this.isTransition  
          this.$router.push('UBCNumbersIn2025')
          let self = this
          setTimeout(function(){self.isTransition = false}, 1499,);
        } else if (pathatual === "/UBCNumbersIn2025") {
          this.isTransition = !this.isTransition
          this.$router.push('MainActivities')
          let self = this
          setTimeout(function(){ self.isTransition = false }, 1499);
        }else if (pathatual === "/MainActivities") {
          // final //
        }
      },
      goBack: function(){
        this.clicked = true;
        setTimeout(function(){
           this.clicked = false;
        }.bind(this),1499);
        let pathatual = this.$route.path;
        if (pathatual === "/FewWordFromOurCEO") {
          this.$router.push('/')
        }else if (pathatual === "/Collections") {
          this.$router.push('FewWordFromOurCEO')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){self.isTransition = false}, 1499,);
        }else if (pathatual === "/Distributions") {
          this.$router.push('Collections')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){self.isTransition = false}, 1499,);
        }else if (pathatual === "/OurChiefOperatingOfficersAnalysiss") {
          this.$router.push('Distributions')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){self.isTransition = false}, 1499,); 
        } else if (pathatual === "/UBCNumbersIn2025") {
          this.$router.push('OurChiefOperatingOfficersAnalysiss')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){self.isTransition = false}, 1499,);
        } else if (pathatual === "/MainActivities") {
          this.$router.push('UBCNumbersIn2025')
          this.isTransition = !this.isTransition 
          let self = this
          setTimeout(function(){self.isTransition = false}, 1499,);
        } 
      },
      
      onkeydown: function(e){
        let tecla = e.keyCode;
        let pathatual = this.$route.path;  
        const currentTime = Date.now()
    
        if(tecla == 39 && pathatual === "/" && currentTime - this.lastKeyTime > 1499) {   
          console.log("ds")
          this.$router.push('FewWordFromOurCEO')
        } else if(tecla == 37 && pathatual === "/") {   
          // nada
        } else if(tecla == 39 && pathatual === "/FewWordFromOurCEO" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('Collections')
          this.isTransition = !this.isTransition 
          let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        } else if(tecla == 37 && pathatual === "/FewWordFromOurCEO" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('/')
        } else if(tecla == 39 && pathatual === "/Collections" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('Distributions')
          this.isTransition = !this.isTransition 
          let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 37 && pathatual === "/Collections" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('FewWordFromOurCEO')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 39 && pathatual === "/Distributions" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('OurChiefOperatingOfficersAnalysiss')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 37 && pathatual === "/Distributions" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('Collections')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 39 && pathatual === "/OurChiefOperatingOfficersAnalysiss" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('UBCNumbersIn2025')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 37 && pathatual === "/OurChiefOperatingOfficersAnalysiss" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('Distributions')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 39 && pathatual === "/UBCNumbersIn2025" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('MainActivities')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 37 && pathatual === "/UBCNumbersIn2025" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('OurChiefOperatingOfficersAnalysiss')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }else if(tecla == 39 && pathatual === "/MainActivities" && currentTime - this.lastKeyTime > 1499) {   
          // nada
        }else if(tecla == 37 && pathatual === "/MainActivities" && currentTime - this.lastKeyTime > 1499) {   
          this.$router.push('UBCNumbersIn2025')
          this.isTransition = !this.isTransition 
            let self = this
            setTimeout(function(){self.isTransition = false}, 1499,);
        }
        this.lastKeyTime = currentTime;
      } 
  },
  
};
</script>

<style>

</style>
